import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/megaphone-off.vue
var s = {
	name: "DtIconMegaphoneOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--megaphone-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Megaphone Off",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M.646.646a.5.5 0 0 1 .708 0L4.977 4.27a.512.512 0 0 1 .013.013l3.928 3.928a.508.508 0 0 1 .01.01l2.426 2.425a.5.5 0 0 1-.708.708L8.32 9.027l-2.048-.455a2.004 2.004 0 0 1-3.903-.867l-.976-.217A.5.5 0 0 1 1 7V5.5a.5.5 0 0 1 .366-.482l2.305-.64L.646 1.354a.5.5 0 0 1 0-.708ZM4.483 5.19 2 5.88v.719l5.003 1.11-2.52-2.52ZM3.349 7.923a1.005 1.005 0 0 0 1.94.43l-1.94-.43Zm7.454-5.321A.5.5 0 0 1 11 3v4.67a.5.5 0 0 1-1 0V3.658l-3.021.839a.5.5 0 0 1-.268-.964l3.655-1.015a.5.5 0 0 1 .437.084Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=megaphone-off.js.map